// Fetch by header id
export const FETCH_ARTICLE_WORDS_BY_HEADER_ID_LOAD_REQUEST = 'FETCH_ARTICLE_WORDS_BY_HEADER_ID_LOAD_REQUEST';
export const FETCH_ARTICLE_WORDS_BY_HEADER_ID_LOAD_SUCCESS = 'FETCH_ARTICLE_WORDS_BY_HEADER_ID_LOAD_SUCCESS';
export const FETCH_ARTICLE_WORDS_BY_HEADER_ID_LOAD_FAILURE = 'FETCH_ARTICLE_WORDS_BY_HEADER_ID_LOAD_FAILURE';

// Fetch by header ids
export const FETCH_ARTICLE_WORDS_BY_HEADER_IDS_LOAD_REQUEST = 'FETCH_ARTICLE_WORDS_BY_HEADER_IDS_LOAD_REQUEST';
export const FETCH_ARTICLE_WORDS_BY_HEADER_IDS_LOAD_SUCCESS = 'FETCH_ARTICLE_WORDS_BY_HEADER_IDS_LOAD_SUCCESS';
export const FETCH_ARTICLE_WORDS_BY_HEADER_IDS_LOAD_FAILURE = 'FETCH_ARTICLE_WORDS_BY_HEADER_IDS_LOAD_FAILURE';
